import { render, staticRenderFns } from "./RolesAdvanced.vue?vue&type=template&id=03fd848e&scoped=true"
import script from "./RolesAdvanced.vue?vue&type=script&lang=js"
export * from "./RolesAdvanced.vue?vue&type=script&lang=js"
import style0 from "./RolesAdvanced.vue?vue&type=style&index=0&id=03fd848e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd848e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
